import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

import { PolicyService } from './policy.service';

export const Ng1PolicyModule = angular
  .module('control-room.commons.services.policy', [])
  .factory('crPolicyService', downgradeInjectable(PolicyService));
